import { Component, inject } from '@angular/core';
import { CanaryService } from './canary.service';

/**
 * The "you are on the canary build" marker: pinned to the viewport's top-left corner, above
 * everything around it, and out of layout flow so it never shifts the toolbar's logo or buttons.
 *
 * It lives in the toolbar's template rather than app.component's, and that placement is what makes
 * the z-index work. Previously it was a `position: fixed` child of app.component and had to pick a
 * number that beat the sticky toolbar but lost to modal dialogs — impossible, because the toolbar
 * and `.cdk-overlay-container` are BOTH `z-index: 1000`. At 9999 it floated over dialogs; at 999
 * the toolbar painted over it and canary mode looked switched off while it was on.
 *
 * Inside the toolbar there is no such contest: `z-index: 1000` on `mat-toolbar` opens a stacking
 * context, so this badge's 9999 only ranks it *within* the header — it paints above the logo, while
 * the whole subtree still sits at 1000 and the later-in-DOM overlay container keeps covering it.
 * Visible, layout-neutral, and still underneath dialogs.
 */
@Component({
  selector: 'app-canary',
  imports: [],
  template: `
    @if (canary.enabled) {
      <div (click)="canary.disable()" class="canary">
        canary-version<br />
        exit test
      </div>
    }
  `,
  styles: [
    `
      .canary {
        opacity: 0.5;
        text-align: center;
        font-size: 12px;
        white-space: nowrap;
        cursor: pointer;
        /* Out of flow on purpose: as a flex child it added ~90px to the toolbar and pushed the
           logo and buttons sideways whenever canary mode was on. */
        position: fixed;
        top: 0;
        left: 0;
        z-index: 9999;
        border: 0.5px solid #f22;
        background: #fdd;
        color: #000;
        padding: 0 5px;
      }
    `,
  ],
})
export class CanaryComponent {
  canary = inject(CanaryService);
}
